import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@lanl-web/lanl-components';
import { getImageUrl } from '../../utils';
import './ArticleBanner.scss';

export const ArticleBanner = ({
  categoryOverride,
  contentSide,
  defaultImage,
  story,
  secondBtn,
}) => {
  const category = categoryOverride
    ? categoryOverride
    : story?.main_topic?.tag_name ?? '';
  const featuredImage = getImageUrl(story?.feature_image?.filename_disk ?? '');
  const title = story?.title ?? '';
  const subtitle = story?.subtitle ?? '';

  return (
    <Banner
      category={category}
      featuredImage={featuredImage}
      btnLink={'#'}
      title={title}
      subtitle={subtitle}
      contentSide={contentSide}
      className='article-banner'
      target='_self'
    />
  );
};

ArticleBanner.defaultProps = {
  contentSide: 'left',
  secondBtn: false,
};

ArticleBanner.propTypes = {
  defaultImage: PropTypes.string.isRequired,
  story: PropTypes.object.isRequired,
  categoryOverride: PropTypes.string,
  contentSide: PropTypes.string,
  secondBtn: PropTypes.bool,
};

export default ArticleBanner;
